import {
  GetMembresiaTracking,
  PostMembresiaTracking
} from "../../../reducers/comisionMembresia";

export interface TrackingClubesStore
  extends GetMembresiaTracking,
    PostMembresiaTracking {}

export const trackingClubesStore: (state) => TrackingClubesStore = state => {
  const comisionMembresiaState = state.comisionMembresia;

  return {
    membresiaTracking: comisionMembresiaState.membresiaTracking,
    gettingMembresiaTracking: comisionMembresiaState.gettingMembresiaTracking,
    gettingMembresiaTrackingError:
      comisionMembresiaState.gettingMembresiaTrackingError,

    postMembresiaTrackingResult:
      comisionMembresiaState.postMembresiaTrackingResult,
    postingMembresiaTracking: comisionMembresiaState.postingMembresiaTracking,
    postingMembresiaTrackingError:
      comisionMembresiaState.postingMembresiaTrackingError
  };
};
